export default {"src":"/_next/static/image/public/images/ic_filter.1c9510e8f5a91b5b792fb37e5256017a.svg","height":9,"width":17};